<template>
  <el-container>
    <router-view v-wechat-title="$route.meta.title" name="whtitle" ref="whtitle"></router-view>
    <el-container>
      <router-view name="aside" ref="aside" @eventSelectItemPath="callHeaderNode" />
      <router-view name="header" ref="header"></router-view>
      <el-main>
        <router-view name="default" ref="default" class="el-main-container" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  methods: {
    callHeaderNode(obj) {
      this.$refs.header.addTabPane(obj);
      console.log('子组件方法被调用'); // 这里是你要调用的方法。通常不需要在父组件中直接调用。你可以在父组件中触发一个事件，让子组件内部处理。例如：this.$emit('child-method-called'); 然后父组件监听这个事件并做相应处理。或者，如果你想在父组件中直接调用，可以继续使用上面的方法，但通常这不是推荐的做法。更推荐的做法是使用下面的模式：
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  border: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}

body > .el-container {
  display: block;
}

section.el-container {
  display: block;
  background-color: #ffffff;
}

.el-main-container {
  padding-top: 10px;
  padding-left: 10px;
}

.el-header {
  padding: 0;
  text-align: center;
}

.el-aside {
  float: left;
  position: absolute;
  color: #333;
  border-right: #dddddd 1px solid;
  text-align: center;
  height: 100vh;
}

.logo-container {
  height: 60px;
  text-align: center;
  border-bottom: #dddddd 1px solid;
  background: #ffffff;
}

.logo-image {
  margin-top: 2px;
  width: 58px; 
  height: 56px;
}

.el-main { 
  padding-left: 210px;
  padding-top: 10px;
  width: 100%;
  height: calc(100vh - 70px);
  background-color: #f8f8f8;
}

.br-ok {
  width: calc(100% + 10px);
  height: 10px;
  margin-left: -10px;
  line-height: 10px;
  background-color: #f8f8f8;
}

.elform-operate-control {
  padding-top: 10px;
}

.el-button--primary {
    background-color: #5e4bd8;
    border-color: #5e4bd8;
}

.sanmuui-body-container {
  height: calc(100vh - 165px);           /* 高度固定 */
  width: 100%;             /* 宽度根据父容器变化 */
  display: flex;           /* 开启 Flex 布局 */
  border-radius: 6px;
  overflow: hidden;        /* 防止子元素溢出圆角 */
}
 /* 左侧：宽度固定 */
.sanmuui-body-left {
  flex: 0 0 200px;         /* 等同于 flex-grow:0; flex-shrink:0; flex-basis:200px; */
  color: #fff;
  display: flex;
  align-items: center;     /* 内容垂直居中 */
  justify-content: center; /* 内容水平居中 */
  border-top: #dddddd 1px solid;
}

/* 右侧：宽度自动延申 */
.sanmuui-body-right {
  flex: 1;                 /* 占据剩余的所有空间 */
  overflow: auto;          /* 内容过多时出现滚动条，保护布局 */
}

.fm-select-control {
    height: 30px;
    width: 160px;
}

.el-header>.el-menu--horizontal>.el-menu-item {
  height: 50px;
  /*line-height: 50px;*/
}
.el-menu--horizontal>.el-menu-item {
  font-size: 16px;
}
.el-menu--horizontal>.el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
}

.el-header>.el-menu--horizontal>.personNav {
  float: right;
}

.el-header>.el-menu--horizontal>.menu-blank-space {
  width: 200px;
}

.el-menu-item.is-active {
  background-color: #f0edfd !important;
}
.el-tabs__nav>.el-tabs__item {
  height: 35px;
  line-height: 35px;
}

.dv-pagging-container {
  padding-top: 10px;
  text-align: center;
}

.table-list-show {
  padding: 10px;
}
.table-list-show .el-row {
  padding-top: 5px;
  padding-bottom: 5px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 170px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 10px;
}

.-form2-input-text {
  width: 300px;
}

.fm3-input-text-wth {
  width: 100px;
}

.child-menu-title {
  font-size: 14px;
  color: #333333;
}

.tree-divBox {
  padding-top: 20px;
  padding-left: 10px;
  margin-bottom: 5px;
  width: 98%;
  min-height: 480px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.floating-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 确保在最上层 */
  background: rgba(0, 0, 0, 0.5);
}
.layer-content {
  background: white;
  padding: 10px;
  width: 270px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 4px 4px 2px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1001; /* 确保在遮罩之上 */
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 半透明遮罩 */
}
.input-holdName {
  width:88px;
}

.el-tabs__header {
  padding-top: 5px;
  position: relative;
  margin: 0;
}
.el-header {
  padding: 0;
  text-align: center;
  line-height: 40px;
}
/* 导航菜单激活样式 */
.el-tabs__item.is-active {
    color: #409EFF;
    font-weight: bold;
}
.el-tabs--card>.el-tabs__header .el-tabs__nav {
  background-color: #ffffff;
  margin-top: 2.5px;
}
.el-tabs--card>.el-tabs__header .el-tabs__item {
  border-bottom: 1px solid #cccccc;
}
.static-total-records {
  margin-left: 10px;
  font-size: 16px;
  color: #000fff;
}
</style>